module.exports = __webpack_public_path__ + "img/404.abdec79.svg";